import { render, staticRenderFns } from "./ClassStudentList.vue?vue&type=template&id=554254aa&scoped=true"
import script from "./ClassStudentList.vue?vue&type=script&lang=js"
export * from "./ClassStudentList.vue?vue&type=script&lang=js"
import style0 from "./ClassStudentList.vue?vue&type=style&index=0&id=554254aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554254aa",
  null
  
)

export default component.exports